import { useState } from "react";
import { categories } from "@/mocks/baogua";

export default function CategorySection() {
  const [active, setActive] = useState(categories[0].id);

  return (
    <section id="category" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-price-tag-3-fill"></i> 六大吃瓜频道
            </span>
            <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
              挑个<span className="font-display text-secondary-600">频道</span>开吃
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              按你最爱的话题选一个入口，每个频道都是实时更新的专题瓜场与深度长文集合。
            </p>
          </div>
          <div className="hidden flex-wrap items-center gap-2 lg:flex">
            {categories.map((c) => (
              <button key={c.id} onClick={() => setActive(c.id)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold transition ${active === c.id ? "bg-primary-500 text-background-50" : "bg-background-200/70 text-foreground-700 hover:bg-background-200"}`}>
                {c.name}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-4 flex flex-wrap items-center gap-2 lg:hidden">
          {categories.map((c) => (
            <button key={c.id} onClick={() => setActive(c.id)}
              className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold transition ${active === c.id ? "bg-primary-500 text-background-50" : "bg-background-200/70 text-foreground-700"}`}>
              {c.name}
            </button>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {categories
            .filter((c) => c.id === active || true)
            .map((c) => (
              <article key={c.id}
                className={`group relative overflow-hidden rounded-2xl bg-background-100 p-5 transition ${c.id === active ? "ring-2 ring-primary-300" : ""}`}>
                <div className="flex items-start justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-background-50 to-background-200 text-2xl text-primary-600 group-hover:text-accent-500 transition">
                    <i className={c.icon}></i>
                  </span>
                  <span className="rounded-full bg-background-50 px-2.5 py-1 text-xs text-foreground-500">{c.count} 篇</span>
                </div>
                <h3 className="mt-4 text-lg font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-1 text-sm text-foreground-600">{c.desc}</p>
                <button onClick={() => setActive(c.id)}
                  className="mt-4 flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 transition">
                  去这个频道吃瓜 <i className="ri-arrow-right-line"></i>
                </button>
              </article>
            ))}
        </div>
      </div>
    </section>
  );
}